module.exports = "<p *ngFor=\"let value of values\">\n  {{value}}\n</p>\n"